// Action Types
export const SET_COMPANY_DATA = 'SET_COMPANY_DATA';
export const SET_COMPANY_LOADING = 'SET_COMPANY_LOADING';
export const SET_COMPANY_ERROR = 'SET_COMPANY_ERROR';

// Initial State
const initialState = {
  companyData: null,
  loading: false,
  error: null
};

// Action Creators
export const setCompanyData = (data) => ({
  type: SET_COMPANY_DATA,
  payload: data
});

export const setCompanyLoading = (isLoading) => ({
  type: SET_COMPANY_LOADING,
  payload: isLoading
});

export const setCompanyError = (error) => ({
  type: SET_COMPANY_ERROR,
  payload: error
});

// Reducer
const myCompanyReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_COMPANY_DATA:
      return {
        ...state,
        companyData: action.payload,
        loading: false
      };
    case SET_COMPANY_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    case SET_COMPANY_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      };
    default:
      return state;
  }
};

export default myCompanyReducer;
